<template>
  <!-- <el-dialog
  title="创建设备"
  :visible.sync="dialogVisible"
  width="1300px"
  :before-close="exit"> -->

  <div class="root">
    <div class="top" style="position: relative;">
      <div>
        <div style="display: flex;">
          <img @click="$parent.isSetIsCreate(false)" style="height: 20px;position: relative;top: 5px;margin-right: 10px;cursor: pointer;" src="../../../../assets/custom-image/back.png" alt="">
          <h2>分类</h2>
        </div>
        <div style="position:relative;top:12px">产品是一组具有相同功能定义的设备集合,创建产品是使用本平台的开始</div>
        <!-- <el-button  icon="el-icon-back" style="height: 35px;position: absolute;right: 0;top: 0;" :size="this.$store.state.btnSize"  @click="$parent.isSetIsCreate(false)">返回</el-button> -->
      </div>
      <div>
        <div style="display: flex;justify-content: space-between;">
          <h3>标准类目</h3>
              <el-button
                style="width: 108px;height: 35px;position: relative;top: 17px;"
                icon="el-icon-circle-plus-outline"
                :size="this.$store.state.btnSize"
                @click="addOredit(-1)"
                >新增分类</el-button
            >
          </div>  
        <div></div>
      </div>
    </div>
    <div class="bottom-root">
      <div class="left" :style="{'height':(this.$store.state.windowHeight-260)+'px'}">
        <div class="left-box" :class="{'left-active':leftIndex == index}" @click="typeSelectBtn(index,item)" v-for="(item,index) in leftList">
          <span>{{ item.classifyName }}</span>
          <div class="toopls">
            <el-button type="text" @click.stop="addOredit(1,item)">新增</el-button>
            <el-button type="text" @click.stop="addOredit(2,item)">编辑</el-button>
            <el-button type="text" @click.stop="addOredit(3,item)">删除</el-button>
          </div>
        </div>
        <!-- <div class="left-box" style="justify-content: center;color: #9e9d9d;background-color: transparent;border: 1px dashed rgba(0,0,0,0.1);" @click="addOredit(-1)">
          <i class="el-icon-plus" style="margin-right: 5px;"></i>
          创建分类
        </div> -->
      </div>
      <div class="right-container" :style="{'height':(this.$store.state.windowHeight-260)+'px'}">
        <div style="color: #333333;line-height: 22px;margin-top: 15px;margin-bottom: 10px;font-size: 13px;">请选择你想要创建的产品<span style="color: #c6c6c6;margin-left: 10px;">( 单击分类 增加设备 )</span></div>
        <div class="right">
          <div class="right-box"  v-show="isSelectDev && rightList.length != 0" v-for="(item,index) in rightList" :key="index">
            <div class="title">
              <span v-show="!item.input">{{ item.classifyName }}</span>
              <el-input style="width: 150px;" v-model="item.classifyName" v-show="item.input"></el-input>
              <el-button type="text" v-show="!item.input" @click="editInput(item)" style="margin-left: 10px;">编辑</el-button>
              <el-button type="text" v-show="!item.input" @click="addOredit(5,item)" style="margin-left: 10px;">新增</el-button>
              <el-button type="text" v-show="!item.input" @click.stop="addOredit(3,item)">删除</el-button>
              <el-button type="text" v-show="item.input" @click="save(item)" style="margin-left: 10px;">保存</el-button>
            </div>
            <div class="bottom">
              <!-- @dblclick="devSelectBtn(childrenIndex+''+index,childreanItem)"  -->
              <div class="box" style="box-sizing: border-box;padding-right: 10px;" v-for="(childreanItem,childrenIndex) in item.childClassify" :class="{'right-active':rightIndex == childrenIndex+''+index}" @click="addOredit(-3,childreanItem)" :key="childrenIndex">
                <!-- <img :src="childreanItem.icon" alt=""> -->
                <el-image style="width: 70px;height: 100%;border-radius: 10px;margin-right: 5px;" :src="childreanItem.icon">
                  <div slot="error">
                    <i style="font-size: 30px;position: relative;top: 3px;" class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <span>{{ childreanItem.classifyName }}</span>
                <el-button type="text" @click.stop="addOredit(2,childreanItem)">编辑</el-button>
                <el-button type="text" @click.stop="addOredit(3,childreanItem)">删除</el-button>
              </div>
              <div v-if="false" class="box" style="justify-content: center;color: #9e9d9d;" @click="addOredit(-2,item)">
                <i class="el-icon-plus" style="margin-right: 5px;"></i>创建产品
              </div>
              <!-- 空数据显示 -->
              <div v-if="item.childClassify == 0" class="box" style="justify-content: center;color: #9e9d9d;" >
                暂无数据
              </div>
            </div>
          </div>
          <div v-show="rightList.length == 0">
              <el-empty description="暂无设备"></el-empty>
            </div>

          <!-- 新增设备 目前没有用到 -->
          <div v-show="!isSelectDev" class="right-next-root">
            <div class="next-box">
              <div class="next-title">
                <div class="required">*</div>
                产品名称
              </div>
              <div class="next-content">
                <el-input></el-input>
              </div>
            </div>
            <div class="next-box">
              <div class="next-title">
                产品型号
              </div>
              <div class="next-content">
                <el-input></el-input>
              </div>
            </div>
            <div class="next-box">
              <div class="next-title">
                <div class="required">*</div>
                通讯协议
              </div>
              <div class="next-content">
                <el-radio v-for="(item,index) in radioList" :key="index" v-model="radio" :label="item.id">{{ item.label }}</el-radio>
              </div>
            </div>
            <div class="next-box">
              <div class="next-title">
                <div class="required">*</div>
                功耗类型
              </div>
              <div class="next-content">
                <el-radio v-model="radios" label="1">标准功耗</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左侧 -->
      <leftAddEdit ref="leftAddEdit"></leftAddEdit>
      <!-- 右侧 -->
      <rightAddEdit ref="rightAddEdit"></rightAddEdit>
    </div>
  </div>
  <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ isSelectDev?'取 消':'上一步' }}</el-button>
      <el-button type="primary" v-show="!isSelectDev" @click="dialogVisible = false">确 定</el-button>
    </span> -->

  <!-- </el-dialog> -->
</template>

<script>
import { iotApi } from '../../../../utils/config'
import { getFun, postFun } from '../../../../utils/httpFun';
import leftAddEdit from './create/left/left-add-edit.vue'
import rightAddEdit from './create/right/right-add-edit.vue'
export default {
  components:{
    leftAddEdit,
    rightAddEdit
  },
  data() {
    return {
      leftList:[],
      rightList:[],
      radioList:[
        {
          id:1,
          label:'WIFI-蓝牙'
        },
        {
          id:2,
          label:'WI-FI'
        },
        {
          id:3,
          label:'Zigbee'
        },
        {
          id:4,
          label:'狼牙'
        },
        {
          id:5,
          label:'其他'
        }
      ],
      typeClass:{},
      radio:1,
      radios:1,
      dialogVisible:false,
      rightIndex:-1,
      leftIndex:0,
      isSelectDev:true
    };
  },
  methods:{
    exit(){
      this.rightIndex = -1;
      this.leftIndex = 0;
      this.isSelectDev = true;
      this.leftList = [];
      this.dialogVisible = false;
    },
    open(item){
      this.dialogVisible = true;
      console.log('=====打开')
      this.getLeftListFun();
    },
    close(){
      if(!this.isSelectDev){
        this.isSelectDev = true;
        return;
      }
      this.rightIndex = -1;
      this.leftIndex = 0;
      this.isSelectDev = true;
      this.leftList = [];
      this.dialogVisible = false;
    },
    devSelectBtn(index,item){
      this.rightIndex = index
      console.log('右边',item);
      let closeBtn = ()=>{
        console.log('==========成功11')
        this.getLeftListFun();
        this.$parent.searchBtn();
      }
      this.$refs.rightAddEdit.open('edit',item,closeBtn);
      // this.isSelectDev = false; 打开新增产品的页面目前无用
    },
    typeSelectBtn(index,item){
      console.log('--------测试leftList',index,item)
      this.leftIndex = index;
      this.typeClass = item;
      this.getDevList(item.cId);
    },
    // 右侧方法
    getDevList(cid){
      getFun(iotApi.SELECTDTOBYCID,{cId:cid},res=>{
        console.log('查询设备',res);
        this.rightList = res.data || [];
      })
    },
    // 左侧方法
    // 查询左侧分类
    getLeftListFun(type = 'exit'){
      getFun(iotApi.SELECTDTOBYCID,{cId:0},res=>{
        console.log('查询分类',res);
        this.leftList = res.data || [];
        this.leftList.length == 0?'': this.getDevList(this.leftList[this.leftIndex].cId);
        try{
          this.typeClass = this.leftList[0];
        }catch{
          this.typeClass = {};
        }
        if(type != 'exit'){
          this.$parent.searchBtn();
        }
      })
    },
    addOredit(index,item){
      if(index == -1){
        console.log('增加');
        this.$refs.leftAddEdit.open('add',item,this.getLeftListFun);
      }else if(index == 1){
        console.log('增加子类');
        this.$refs.leftAddEdit.open('addChildrean',item,this.getLeftListFun);
      }
      else if(index == 2){
        console.log('编辑');
        this.$refs.leftAddEdit.open('edit',item,this.getLeftListFun);
      }
      else if(index == 3){
        console.log('删除');
        this.$confirm('是否删除该分类?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getFun(iotApi.DELETEDTOCLASS,{cId:item.cId},res=>{
            console.log('删除分类',res);
            if(res.data){
              this.$message.success('删除成功');
              this.getLeftListFun();
              if(this.leftList != 0){
                let obj = this.leftList.findIndex(items=>items.cId == item.cId);
                console.log('--------obj',obj);
                if(this.leftIndex == obj)this.typeSelectBtn(--this.leftIndex,this.leftList[this.leftIndex])
              }
            }else{
              this.$message.warning('删除失败');
            }
          })
        })
      }
      else if(index == -2){
        console.log('产品增加',item.cId);
        this.$refs.rightAddEdit.open('add',item,this.getLeftListFun);
      }else if(index == 5){
        console.log(item,this.leftList[this.leftIndex])
        let cid = this.leftList[this.leftIndex].cId+','+item.cId;
        console.log('产品增加',cid,{...item,cId:cid});
        this.$refs.leftAddEdit.open('threeAddChild',{...item,cId:cid},this.getLeftListFun);
      }else if(index == -3){
        console.log('产品增加',item);
        this.$refs.rightAddEdit.open('add',item,(data)=>{
          console.log('产品增加---',data);
          this.$parent.openExploitPage(data);
          this.getLeftListFun();
        });
      }
    },
    editInput(item){
      item.input = true;
      console.log('=========',item);
      this.$forceUpdate()
    },
    save(item){
      console.log('保存',this.typeClass,item);

      let param = {
        cId:item.cId,
        classifyName:item.classifyName
      }

      console.log('param',param)

      postFun(iotApi.UPDATECATEGORYPRODUCTBYID,param,res=>{
        if(res.data){
          this.$message.success('保存成功');
          item.input = false;
          this.$forceUpdate()
        }else {
          this.$message.warning('保存失败');
        }
      })

      item.input = false;
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-button{
    border-radius: 6px;
  }
  .root{
    padding-top: 15px;
    padding-left: 23px;
    padding-right: 23px;
    padding-bottom: 15px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
   
  }
  .top{
    div:nth-child(1){
      div:nth-child(2){
        color: #949AA6;
        font-size: 14px;
      }
    }
    div:nth-child(2){
      h3{
        margin-top: 30px;
        margin-bottom: 8px;
      }
      div:last-child{
        border: 1px solid #ECEEF099;
        position: relative;

        &::after{
          content: '';
          position: absolute;
          left: 0;
          top: -1px;
          display: block;
          clear: both;
          width: 80px;
          height: 3px;
          background: #4990FF;

        }
      }
    }
  }
  .bottom-root{
    // height: 100%;
    height: 88%;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .left{
    position: relative;
    // width: 13%;
    width: 235px;
    border-right: 1px solid #ECEEF099;
    height: 100%;
    // border-radius: 6px; 
    box-sizing: border-box;
    padding: 10px;
    padding-left: 0;
    padding-top: 6px;
    overflow: scroll;
    overflow-x: hidden;
    .left-box{
      cursor: pointer;
      height: 40px;
      margin-bottom: 10px;
      border-radius: 6px;
      padding-bottom: 3px;
      // background-color: rgba(238, 238, 238, 0.527);
      box-sizing: border-box;
      // padding-left: 15px;
      // padding-top: 11px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow:ellipsis;
      span{
        width: 60px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow:ellipsis;
      }
    }
  }
  .right-container{
    box-sizing: border-box;
    width: 100%;
    // padding: 10px;
    padding-top: 0;
    padding-left: 20px;
    // padding-right: 20px;
    padding-bottom: 20px;
  }
  .right{
    position: relative;
    width: 100%;
    height:93%;
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 10px;
    // box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.2);
    box-sizing: border-box;
    padding: 15px;
    padding-right: 70px;
    overflow: scroll;
    overflow-x: hidden;
    .right-box{
      margin-bottom: 0px;
      display: flex;
      flex-direction: column;
      .box{
        color: #333333;
        font-size: 14px;
        cursor: pointer;
        width: calc(100% / 6 - 10px);
        height: 43px;
        box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        float: left;
        margin-left: 10px;
        margin-bottom: 10px;
        border-radius: 5px;
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        &:hover{
          box-shadow: 0px 0px 3px 0px rgb(1, 166, 255);
        }
      }
      .bottom{
        
      }
      .title{
        padding-left: 10px;
        margin-bottom: 10px;
        color: #333333;
        font-size: 12px;
      }
      img{
        width: 30px;
        height: 100%;
        border-radius: 10px;
        margin-right: 5px;
      }
      span{
        width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .right-active{
    box-shadow: inset 1px 1px 3px 0px rgba(0, 0, 0, 0.2) !important;
  }
  .left-active{
    color: #4990FF;
    line-height: 22px;
    background-color: #EBF3FF !important;
  }
  ::v-deep .el-dialog__header{
    width: 96.7%;
    height: 23px;
    // background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
    margin-bottom: 20px;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }

  .right-next-root{
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    padding-top: 50px;
    .next-title{
      margin-bottom: 15px;
    }
    .next-content{
      position: relative;
      margin-bottom: 30px;
    }
    .required{
      left: 25px;
      position: absolute;
      color: red;
    }
  }
  ::v-deep .el-input__inner{
    height: 27px !important;
  }
</style>